<template>
  <div class="wl-action-editor wl-form">
    <template v-if="action.type === 'hover'">
      <div class="wl-field">
        <label>悬停时间</label>
        <div class="wl-bigstep">
          <button type="button" @click="stepNumber('hoverTime', -100, 0.5, 600)">-100</button>
          <button type="button" @click="stepNumber('hoverTime', -10, 0.5, 600)">-10</button>
          <button type="button" @click="stepNumber('hoverTime', -1, 0.5, 600)">-1</button>
          <b>{{ action.params.hoverTime }}<small>s</small></b>
          <button type="button" @click="stepNumber('hoverTime', 1, 0.5, 600)">+1</button>
          <button type="button" @click="stepNumber('hoverTime', 10, 0.5, 600)">+10</button>
          <button type="button" @click="stepNumber('hoverTime', 100, 0.5, 600)">+100</button>
        </div>
      </div>
    </template>

    <template v-if="action.type === 'rotateYaw'">
      <div class="wl-field">
        <label>飞行器偏航角</label>
        <div class="wl-slider">
          <button type="button" @click="stepNumber('aircraftHeading', -1, -180, 180)"><MinusOutlined /></button>
          <a-slider :value="Number(action.params.aircraftHeading)" :min="-180" :max="180" :tip-formatter="null" @change="set('aircraftHeading', $event)" />
          <button type="button" @click="stepNumber('aircraftHeading', 1, -180, 180)"><PlusOutlined /></button>
          <b>{{ action.params.aircraftHeading }}°</b>
        </div>
        <p class="wl-action-editor__hint">0° 为正北，顺时针为正。</p>
      </div>
      <div class="wl-field">
        <label>旋转方向</label>
        <a-radio-group size="small" :value="action.params.aircraftPathMode" @change="set('aircraftPathMode', $event.target.value)">
          <a-radio-button value="clockwise">顺时针</a-radio-button>
          <a-radio-button value="counterClockwise">逆时针</a-radio-button>
        </a-radio-group>
      </div>
    </template>

    <template v-if="action.type === 'takePhoto' || action.type === 'startRecord' || action.type === 'panoShot' || action.type === 'orientedShoot' || action.type === 'stopRecord' || action.type === 'startTimedShot' || action.type === 'startDistanceShot'">
      <div class="wl-field">
        <label>存储镜头</label>
        <a-checkbox-group :value="lensList" :options="lensOptions" @change="setLens" />
      </div>
    </template>
    <template v-if="action.type === 'takePhoto' || action.type === 'startRecord' || action.type === 'orientedShoot'">
      <div class="wl-field">
        <label>文件后缀</label>
        <a-input size="small" :value="action.params[action.type === 'orientedShoot' ? 'orientedFileSuffix' : 'fileSuffix']" :maxlength="32" placeholder="可选，附加到媒体文件名" @update:value="set(action.type === 'orientedShoot' ? 'orientedFileSuffix' : 'fileSuffix', $event)" />
      </div>
    </template>

    <template v-if="action.type === 'orientedShoot'">
      <div class="wl-field">
        <label>云台俯仰角</label>
        <div class="wl-slider">
          <button type="button" @click="stepNumber('gimbalPitchRotateAngle', -1, pitchRange[0], pitchRange[1])"><MinusOutlined /></button>
          <a-slider :value="Number(action.params.gimbalPitchRotateAngle)" :min="pitchRange[0]" :max="pitchRange[1]" :tip-formatter="null" @change="set('gimbalPitchRotateAngle', $event)" />
          <button type="button" @click="stepNumber('gimbalPitchRotateAngle', 1, pitchRange[0], pitchRange[1])"><PlusOutlined /></button>
          <b>{{ action.params.gimbalPitchRotateAngle }}°</b>
        </div>
      </div>
      <div class="wl-field">
        <label>飞行器偏航角</label>
        <div class="wl-slider">
          <button type="button" @click="setHeading(Number(action.params.aircraftHeading) - 1)"><MinusOutlined /></button>
          <a-slider :value="Number(action.params.aircraftHeading)" :min="-180" :max="180" :tip-formatter="null" @change="setHeading" />
          <button type="button" @click="setHeading(Number(action.params.aircraftHeading) + 1)"><PlusOutlined /></button>
          <b>{{ action.params.aircraftHeading }}°</b>
        </div>
      </div>
      <div class="wl-field wl-field--inline"><label>变焦焦距 (mm)</label><a-input-number size="small" :value="action.params.focalLength" :min="zoomRange[0]" :max="zoomRange[1]" @update:value="set('focalLength', $event)" /></div>
      <p class="wl-action-editor__hint">定角拍照按记录的姿态重复拍摄；AI 复拍框选需在首飞后通过样片设置。</p>
    </template>

    <template v-if="action.type === 'gimbalRotate'">
      <div class="wl-field">
        <a-checkbox :checked="Boolean(action.params.gimbalPitchRotateEnable)" @change="set('gimbalPitchRotateEnable', $event.target.checked)">云台俯仰角</a-checkbox>
        <div class="wl-slider" :class="{ disabled: !action.params.gimbalPitchRotateEnable }">
          <button type="button" :disabled="!action.params.gimbalPitchRotateEnable" @click="stepNumber('gimbalPitchRotateAngle', -1, pitchRange[0], pitchRange[1])"><MinusOutlined /></button>
          <a-slider :disabled="!action.params.gimbalPitchRotateEnable" :value="Number(action.params.gimbalPitchRotateAngle)" :min="pitchRange[0]" :max="pitchRange[1]" :tip-formatter="null" @change="set('gimbalPitchRotateAngle', $event)" />
          <button type="button" :disabled="!action.params.gimbalPitchRotateEnable" @click="stepNumber('gimbalPitchRotateAngle', 1, pitchRange[0], pitchRange[1])"><PlusOutlined /></button>
          <b>{{ action.params.gimbalPitchRotateAngle }}°</b>
        </div>
      </div>
      <div class="wl-field">
        <a-checkbox :checked="Boolean(action.params.gimbalYawRotateEnable)" @change="set('gimbalYawRotateEnable', $event.target.checked)">云台偏航角（相对正北）</a-checkbox>
        <div class="wl-slider" :class="{ disabled: !action.params.gimbalYawRotateEnable }">
          <button type="button" :disabled="!action.params.gimbalYawRotateEnable" @click="stepNumber('gimbalYawRotateAngle', -1, -180, 180)"><MinusOutlined /></button>
          <a-slider :disabled="!action.params.gimbalYawRotateEnable" :value="Number(action.params.gimbalYawRotateAngle)" :min="-180" :max="180" :tip-formatter="null" @change="set('gimbalYawRotateAngle', $event)" />
          <button type="button" :disabled="!action.params.gimbalYawRotateEnable" @click="stepNumber('gimbalYawRotateAngle', 1, -180, 180)"><PlusOutlined /></button>
          <b>{{ action.params.gimbalYawRotateAngle }}°</b>
        </div>
      </div>
      <div class="wl-field wl-field--inline">
        <a-checkbox :checked="Boolean(action.params.gimbalRotateTimeEnable)" @change="set('gimbalRotateTimeEnable', $event.target.checked)">转动时间 (s)</a-checkbox>
        <a-input-number size="small" :disabled="!action.params.gimbalRotateTimeEnable" :value="action.params.gimbalRotateTime" :min="0" :max="60" @update:value="set('gimbalRotateTime', $event)" />
      </div>
    </template>

    <template v-if="action.type === 'zoom'">
      <div class="wl-field">
        <label>焦距</label>
        <div class="wl-slider">
          <button type="button" @click="stepNumber('focalLength', -1, zoomRange[0], zoomRange[1])"><MinusOutlined /></button>
          <a-slider :value="Number(action.params.focalLength)" :min="zoomRange[0]" :max="zoomRange[1]" :tip-formatter="null" @change="set('focalLength', $event)" />
          <button type="button" @click="stepNumber('focalLength', 1, zoomRange[0], zoomRange[1])"><PlusOutlined /></button>
          <b>{{ action.params.focalLength }} mm</b>
        </div>
      </div>
    </template>

    <template v-if="action.type === 'focus'">
      <div class="wl-field">
        <label>对焦方式</label>
        <a-radio-group size="small" :value="action.params.isInfiniteFocus ? 'infinite' : (action.params.isPointFocus ? 'point' : 'area')" @change="setFocusMode($event.target.value)">
          <a-radio-button value="point">点对焦</a-radio-button>
          <a-radio-button value="area">区域对焦</a-radio-button>
          <a-radio-button value="infinite">无穷远</a-radio-button>
        </a-radio-group>
      </div>
      <div v-if="!action.params.isInfiniteFocus" class="wl-field wl-field--inline">
        <label>对焦位置 X / Y</label>
        <a-input-number size="small" :value="action.params.focusX" :min="0" :max="1" :step="0.05" @update:value="set('focusX', $event)" />
        <a-input-number size="small" :value="action.params.focusY" :min="0" :max="1" :step="0.05" @update:value="set('focusY', $event)" />
      </div>
      <div v-if="!action.params.isInfiniteFocus && !action.params.isPointFocus" class="wl-field wl-field--inline">
        <label>区域宽 / 高</label>
        <a-input-number size="small" :value="action.params.focusRegionWidth" :min="0.01" :max="1" :step="0.05" @update:value="set('focusRegionWidth', $event)" />
        <a-input-number size="small" :value="action.params.focusRegionHeight" :min="0.01" :max="1" :step="0.05" @update:value="set('focusRegionHeight', $event)" />
      </div>
    </template>

    <template v-if="action.type === 'customDirName'">
      <div class="wl-field"><label>文件夹名称</label><a-input size="small" :value="action.params.directoryName" :maxlength="64" @update:value="set('directoryName', $event)" /></div>
    </template>

    <template v-if="action.type === 'startTimedShot'">
      <div class="wl-field wl-field--inline"><label>拍照间隔 (s)</label><a-input-number size="small" :value="action.params.interval" :min="0.5" :max="600" :step="0.5" @update:value="set('interval', $event)" /></div>
      <p class="wl-action-editor__hint">从本航点开始，到“结束间隔拍照”所在航点为止等时拍照。</p>
    </template>
    <template v-if="action.type === 'startDistanceShot'">
      <div class="wl-field wl-field--inline"><label>拍照间距 (m)</label><a-input-number size="small" :value="action.params.interval" :min="0.5" :max="1000" :step="0.5" @update:value="set('interval', $event)" /></div>
      <p class="wl-action-editor__hint">从本航点开始，到“结束间隔拍照”所在航点为止等距拍照。</p>
    </template>
    <p v-if="action.type === 'endIntervalShot'" class="wl-action-editor__hint">结束前一个等时/等距间隔拍照。</p>
    <p v-if="action.type === 'panoShot'" class="wl-action-editor__hint">到达航点后拍摄 360° 全景照片。</p>
  </div>
</template>

<script lang="ts" setup>
/* global defineEmits, defineProps */
import { computed } from 'vue'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons-vue'
import type { PayloadLens, WaypointAction } from '/@/types/wayline-editor'
import { LENS_LABELS } from '/@/utils/wayline-editor'

const props = defineProps<{
  action: WaypointAction
  lenses: PayloadLens[]
  pitchRange: [number, number]
  zoomRange: [number, number]
}>()
const emit = defineEmits(['update'])

const lensOptions = computed(() => props.lenses.map(lens => ({ label: LENS_LABELS[lens], value: lens })))
const lensList = computed(() => String(props.action.params.payloadLensIndex || '').split(',').filter(Boolean))

function set (key: string, value: unknown) {
  if (value === null || value === undefined) return
  emit('update', { ...props.action.params, [key]: value as string | number | boolean })
}

function stepNumber (key: string, delta: number, min: number, max: number) {
  const current = Number(props.action.params[key]) || 0
  set(key, Math.round(Math.min(max, Math.max(min, current + delta)) * 10) / 10)
}

function setLens (values: string[]) {
  if (!values.length) return
  emit('update', { ...props.action.params, payloadLensIndex: values.join(','), useGlobalPayloadLensIndex: false })
}

function setHeading (value: number | null) {
  if (value === null) return
  const heading = Math.max(-180, Math.min(180, Math.round(value)))
  // M3E/M3D/M4D gimbal yaw must match the aircraft heading for oriented shots.
  emit('update', { ...props.action.params, aircraftHeading: heading, gimbalYawRotateAngle: heading })
}

function setFocusMode (mode: 'point' | 'area' | 'infinite') {
  emit('update', { ...props.action.params, isInfiniteFocus: mode === 'infinite', isPointFocus: mode !== 'area' })
}
</script>

<style lang="scss">
.wl-action-editor {
  display: flex; flex-direction: column; gap: 12px;
  &__hint { margin: 0; color: #9a9ea6; line-height: 1.5; }
  .wl-slider.disabled b { color: #6b6f77; }
}
.wl-bigstep {
  display: grid; grid-template-columns: repeat(3, 1fr) auto repeat(3, 1fr); align-items: center; gap: 4px;
  button { height: 26px; border: 0; border-radius: 3px; background: #35373c; color: #fff; cursor: pointer; font-size: 11px; }
  button:hover { background: #4a4d55; }
  b { min-width: 56px; text-align: center; color: #2d8cf0; font-size: 18px; font-weight: 600; font-variant-numeric: tabular-nums; }
  b small { margin-left: 2px; font-size: 11px; color: #9a9ea6; }
}
</style>
